<template>
  <div class="pc-university">
    <!-- 院校头部面包屑部分 -->
    <BreadCrumb :data="breadcrumb" :title="'遗产列表管理'" />
    <StatisticalPanel
      :whichModule="'iheritage'"
      :data="overallData"
    ></StatisticalPanel>
    <ModuleClassfication
      :title="titles"
      class="pc-news-tab"
      @addTopic="addTopic"
      @updateTopic="updateTopic"
      @deleteTopic="deleteTopic"
    />
    <div class="pc-university-table">
      <HeritageTable />
    </div>
  </div>
</template>
<script>
import StatisticalPanel from "../../componentSet/Statistical/StatisticalPanel.vue";
import BreadCrumb from "../../componentSet/BreadCrumb";
import ModuleClassfication from "@/components/componentSet/ModuleClassfication";
import HeritageTable from "./components/HeritageTable";

import {
  getProtectionLevel_Api,
  createProtectionLevel_Api,
  updateProtectionLevel_Api,
  deleteProtectionLevel_Api,
  getSpatialLevel_Api,
  createSpatialLevel_Api,
  updateSpatialLevel_Api,
  deleteSpatialLevel_Api,
  heritageCount_Api,
} from "../../../apis/heritage.api";

export default {
  components: {
    BreadCrumb,
    HeritageTable,
    StatisticalPanel,
    ModuleClassfication,
  },
  computed: {
    breadcrumb: function () {
      return [
        { name: "首页", link: "/admin/main" },
        { name: "遗产列表", link: "/admin/heritageList" },
      ];
    },
  },
  data() {
    return {
      overallData: {
        title: "遗产数据",
        count: [{ name: "遗产数量", count: null }],
      },
      titles: {
        module: "遗产",
        class: [
          { name: "Protection Level", subTitles: [] },
          { name: "Spatial Level", subTitles: [] },
        ],
      },
      count: 0,
    };
  },
  mounted() {
    heritageCount_Api().then((res) => {
      console.log(res.data);
      this.$set(this.overallData.count[0], "count", res.data);
    });
    this.protectionLevelSearch();
    this.spatialLevelSearch();
  },
  methods: {
    updateTopic(topic, callback) {
      if (topic.type == "Protection Level") {
        updateProtectionLevel_Api({
          chinese_name: topic.chinese_name,
          english_name: topic.english_name,
          protection_level_id: topic.id,
          status: topic.status,
        }).then(() => {
          callback();
          this.protectionLevelSearch();
        });
      } else if (topic.type == "Spatial Level") {
        updateSpatialLevel_Api({
          chinese_name: topic.chinese_name,
          english_name: topic.english_name,
          spatial_level_id: topic.id,
          status: topic.status,
        }).then(() => {
          callback();
          this.spatialLevelSearch();
        });
      }
    },

    addTopic(topic, callback) {
      console.log(topic);
      if (topic.type == "Protection Level") {
        createProtectionLevel_Api({
          chinese_name: topic.chinese_name,
          english_name: topic.english_name,
          status: topic.status,
        }).then(() => {
          callback();
          this.protectionLevelSearch();
        });
      } else if (topic.type == "Spatial Level") {
        createSpatialLevel_Api({
          chinese_name: topic.chinese_name,
          english_name: topic.english_name,
          status: topic.status,
        }).then(() => {
          callback();
          this.spatialLevelSearch();
        });
      }
    },
    deleteTopic(topic, callback) {
      if (topic.type == "Protection Level") {
        deleteProtectionLevel_Api({
          protection_level_id: topic.id,
        }).then(() => {
          callback();
          this.protectionLevelSearch();
        });
      } else if (topic.type == "Spatial Level") {
        deleteSpatialLevel_Api({
          spatial_level_id: topic.id,
        }).then(() => {
          callback();
          this.spatialLevelSearch();
        });
      }
    },

    protectionLevelSearch() {
      getProtectionLevel_Api().then((res) => {
        this.$set(this.titles.class[0], "subTitles", res.data);
        console.log(this.titles);
        console.log(res.data);
      });
    },
    spatialLevelSearch() {
      getSpatialLevel_Api().then((res) => {
        this.$set(this.titles.class[1], "subTitles", res.data);
        console.log(this.titles);
        console.log(res.data);
      });
    },
  },
};
</script>
<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/admin/iHeritage/HeritageList.vue